import React from "react";
import "./mindMap.scss";
const MindMap = () => {
  return (
    <section id="price">
      <div className="mind-map">
        <div id="price" name="price" aria-label="price"></div>
        <h2 className="mind-map__title">
          Przypomnę jeszcze, co dokładnie otrzyma każdy kursant:
        </h2>
        <div className="mind-map__content">
          <div className="mind-map__items">
            <div className="mind-map__item">
              <div className="mind-map__item-title">
                Szkolenie dla administratorów IT - Droga Mistrza Admina - w
                dwóch wersjach!
              </div>
              <div className="mind-map__item-description">
                32 lekcje przedstawiające krok po kroku proces tworzenia
                efektywnej i ekonomicznej infrastruktury IT.
              </div>
              <div className="mind-map__item-value">
                Wartość: <b>1 500 PLN</b>
              </div>
            </div>
            <div className="mind-map__item">
              <div className="mind-map__item-title">Case study</div>
              <div className="mind-map__item-description">
                Nagranie z wdrożenia tego rozwiązania u rzeczywistego Klienta z
                moim komentarzem.
              </div>
              <div className="mind-map__item-value">
                Wartość: <b>500 PLN</b>
              </div>
            </div>
            <div className="mind-map__item">
              <div className="mind-map__item-title">
                Cotygodniowe spotkania online ze mną i grupą kursantów.
              </div>
              <div className="mind-map__item-description">
                10+ godzin wspólnego omawiania doświadczeń, rozwiewania
                wątpliwości, chwalenia sukcesami.
              </div>
              <div className="mind-map__item-value">
                Wartość: <b>bezcenne</b>
              </div>
            </div>
            <div className="mind-map__item">
              <div className="mind-map__item-title">
                Pomoc eksperta rozwiązań dla małych i średnich firm.
              </div>
              <div className="mind-map__item-description">
                Spędziłem wiele lat ucząc się przedstawianych rozwiązań i
                przygotowałem to szkolenie maksymalnie praktycznie.
              </div>
              <div className="mind-map__item-value">
                Wartość: <b>bezcenne</b>
              </div>
            </div>

            <div className="mind-map__item">
              <div className="mind-map__item-title">
                Grupa doświadczonych inżynierów
              </div>
              <div className="mind-map__item-description">
                Tworzymy społeczność, w której możesz uzyskać pomoc i wskazówki
                od innych specjalistów.
              </div>
              <div className="mind-map__item-value">
                Wartość: <b>bezcenne</b>
              </div>
            </div>
            <div className="mind-map__item">
              <div className="mind-map__item-title">Faktura</div>
              <div className="mind-map__item-description">
                Po zakupie kursu otrzymasz fakturę, którą możesz odliczyć od
                podatku.
              </div>
            </div>
            <div className="mind-map__item">
              <div className="mind-map__item-title">Gwarancja Satysfakcji</div>
              <div className="mind-map__item-description">
                Jeśli kurs nie będzie dla Ciebie wartościowy, to masz 30 dni na
                rezygnację z zakupu.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MindMap;
